import { ErrorMessage } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { Grid } from '@calendly/ui/components/grid';
import { Icon } from '@calendly/ui/components/icon';
import { Loader } from '@calendly/ui/components/loader';
import { Sheet } from '@calendly/ui/components/sheet';
import classNames from 'classnames';
import { forwardRef } from 'react';
import InterfaceTimeThreeSvg from './icon-interface-time-three.svg';
const interfaceTimeThreeIconCss = "i1k1j67u";
export const InterfaceTimeThreeIcon = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'img';
  const src = InterfaceTimeThreeSvg;
  const alt = '';
  return <Component ref={ref} {...restProps} src={src} alt={alt} className={classNames(interfaceTimeThreeIconCss, props.className)} />;
});
const cardCss = "c6q20c";
export const Card = forwardRef((props, ref) => <Sheet ref={ref} {...props} className={classNames(cardCss, props.className)} />);
const cardHeaderCss = "cdc9fcb";
export const CardHeader = forwardRef((props, ref) => <Grid ref={ref} {...props} className={classNames(cardHeaderCss, props.className)} />);
const arrowIconIsExpandedCss = "a1emkwyc";
const arrowIconCss = "aqymhqo";
export const ArrowIcon = forwardRef((props, ref) => {
  const {
    isExpanded = false,
    ...restProps
  } = props;
  const name = isExpanded ? 'arrow-down-fill' : 'arrow-right-fill';
  return <Icon ref={ref} {...restProps} name={name} className={classNames(arrowIconCss, {
    [arrowIconIsExpandedCss]: isExpanded
  }, props.className)} />;
});
const domainCardTitleCss = "d1nsu1lf";
export const DomainCardTitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(domainCardTitleCss, props.className)} />;
});
const domainCardTitleButtonCss = "dnwuajq";
export const DomainCardTitleButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(domainCardTitleButtonCss, props.className)} />);
const domainCardBodyCss = "d16r7nvm";
export const DomainCardBody = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(domainCardBodyCss, props.className)} />;
});
const domainCardStatusesCss = "d14x9d8w";
export const DomainCardStatuses = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(domainCardStatusesCss, props.className)} />;
});
const domainCardStatusCss = "d1al4nx4";
export const DomainCardStatus = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(domainCardStatusCss, props.className)} />;
});
const domainCardErrorStatusCss = "dfpf2cm";
export const DomainCardErrorStatus = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(domainCardErrorStatusCss, props.className)} />;
});
const closeCircleIconCss = "c117n3ap";
export const CloseCircleIcon = forwardRef((props, ref) => {
  const name = 'close-circle';
  return <Icon ref={ref} {...props} name={name} className={classNames(closeCircleIconCss, props.className)} />;
});
const errorExclamationCircleCss = "eq1sm04";
export const ErrorExclamationCircle = forwardRef((props, ref) => {
  const name = 'exclamation-circle';
  return <Icon ref={ref} {...props} name={name} className={classNames(errorExclamationCircleCss, props.className)} />;
});
const successIconCss = "s58yhzh";
export const SuccessIcon = forwardRef((props, ref) => {
  const name = 'check-circle';
  return <Icon ref={ref} {...props} name={name} className={classNames(successIconCss, props.className)} />;
});
const rowCss = "r280stx";
export const Row = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rowCss, props.className)} />;
});
const rowGridCss = "r1r4yr74";
export const RowGrid = forwardRef((props, ref) => <Grid ref={ref} {...props} className={classNames(rowGridCss, props.className)} />);
const stepCounterCss = "s13j71iv";
export const StepCounter = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(stepCounterCss, props.className)} />;
});
const trashIconCss = "tyrp6li";
export const TrashIcon = forwardRef((props, ref) => {
  const name = 'trash';
  return <Icon ref={ref} {...props} name={name} className={classNames(trashIconCss, props.className)} />;
});
const verifyEnableInformationCss = "v1uuqilz";
export const VerifyEnableInformation = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(verifyEnableInformationCss, props.className)}>
      {I18n.t('publisher.organization_settings.domain_control.cards.verify_enable_info')}
    </Component>;
});
const cardLoaderCss = "c1ecgoh8";
export const CardLoader = forwardRef((props, ref) => <Loader ref={ref} {...props} data-component="loading" data-testid="card-loader" className={classNames(cardLoaderCss, props.className)} />);
const verticalCenterGridCss = "v1wlnpvw";
export const VerticalCenterGrid = forwardRef((props, ref) => <Grid ref={ref} {...props} className={classNames(verticalCenterGridCss, props.className)} />);
const styledErrorMessageCss = "sl5votj";
export const StyledErrorMessage = forwardRef((props, ref) => <ErrorMessage ref={ref} {...props} className={classNames(styledErrorMessageCss, props.className)} />);

require("./shared_styles.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./shared_styles.js");